import { PasswordInput } from "shared/ui/Input";
import { Button } from "shared/ui/button";
import { useHttpRequest } from "shared/lib/hooks/useHttpRequest";
import { resetPasswordRequest } from "features/login/api/resetPasswordRequest";
import {
  validatePasswordResetForm,
  passwordResetValidateOnBlur,
  passwordResetClearOnChange,
} from "../../lib/passwordResetValidation";
import { useFormValidation } from "../../lib/register-validation/common";
import { useUserStore } from "entities/user";
import styles from "../FormStyles.module.scss";

export const PasswordEnterForm = ({ onSuccess, resetToken }) => {
  const { user } = useUserStore();

  const { sendRequest, loading, error, clearError } =
    useHttpRequest(resetPasswordRequest);

  const {
    formData,
    fieldErrors,
    errorMessages,
    requiredFieldsError,
    handleInputChange,
    handleBlur,
    validateForm,
  } = useFormValidation(
    {
      password: "",
      confirmedPassword: "",
    },
    {
      validate: validatePasswordResetForm,
      validateOnBlur: passwordResetValidateOnBlur,
      clearOnChange: passwordResetClearOnChange,
    },
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { isValid, requiredFieldsError: requiredError } = validateForm();

    if (!isValid || loading) return;

    try {
      await sendRequest({
        password: formData.password,
        resetToken,
      });
      onSuccess?.();
    } catch (error) {
      const status = error?.status;

      if (status === 401) {
        return;
      }

      if (status >= 500) {
        return;
      }
    }
  };

  return (
    <form className={styles.formWrapper}>
      <input
        type="text"
        id="username"
        name="username"
        autoComplete="username"
        value={user?.email || ""}
        readOnly
        tabIndex={-1}
        aria-hidden="true"
        className={styles.srOnly}
      />
      <div className={styles.formWrapper__topBlock}>
        <p className={styles.formWrapper__title}>Сброс пароля</p>
        <p className={styles.formWrapper__text}>
          Придумайте новый пароль для авторизации на сайте.
        </p>
      </div>
      <div className={styles.formWrapper__form}>
        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Новый пароль</p>
          <PasswordInput
            value={formData.password}
            onChange={(e) => handleInputChange("password", e.target.value)}
            onBlur={(e) => handleBlur("password", e.target.value)}
            placeholder="Введите пароль"
            autoComplete="new-password"
            className={`${
              fieldErrors.password
                ? styles.formWrapper__inputError
                : styles.formWrapper__input
            } ${styles.formWrapper__passwordBtn}`}
          />
          {errorMessages.password && (
            <span className={styles.formWrapper__errorText}>
              {errorMessages.password}
            </span>
          )}
        </div>

        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Повторите пароль</p>
          <PasswordInput
            value={formData.confirmedPassword}
            onChange={(e) =>
              handleInputChange("confirmedPassword", e.target.value)
            }
            onBlur={(e) => handleBlur("confirmedPassword", e.target.value)}
            placeholder="Введите пароль"
            autoComplete="new-password"
            className={`${
              fieldErrors.confirmedPassword
                ? styles.formWrapper__inputError
                : styles.formWrapper__input
            } ${styles.formWrapper__passwordBtn}`}
          />
          {errorMessages.confirmedPassword && (
            <span className={styles.formWrapper__errorText}>
              {errorMessages.confirmedPassword}
            </span>
          )}
        </div>

        {requiredFieldsError && (
          <span className={styles.formWrapper__greenText}>
            {requiredFieldsError}
          </span>
        )}

        {error && (
          <span className={styles.formWrapper__greenText}>
            Произошла ошибка, попробуйте позже
          </span>
        )}
      </div>

      <div className={styles.formWrapper__buttonBlock}>
        <div className={styles.formWrapper__button}>
          <Button
            variant="primary"
            size="large"
            onClick={handleSubmit}
            type="submit"
          >
            Подтвердить
          </Button>
        </div>
      </div>
    </form>
  );
};
